import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';

let nextRowId = 0;
const emptyDocRow = () => ({ rowId: nextRowId++, name: '', file: null });

// ปุ่ม "จบงาน" — แยกออกจาก dropdown เปลี่ยนสถานะทั่วไป เพราะการันตี WON/LOST ต้อง
// กรอกเลข PO + แนบเอกสารประกอบด้วย (ชื่อเอกสารตั้งเองได้อิสระ ไม่ใช่ TOR/BOQ ตายตัว)
// การเปลี่ยนสถานะ (changeOpportunityStatus) เป็นคน set date_end ให้เองอยู่แล้วที่
// backend (services/marketing/repositories/opportunity.repository.js#changeStatus)
//
// รับ opportunity เป็น argument ตอนเปิด (openDialog(opportunity)) แทนที่จะ fix ไว้ตอน init hook —
// ให้เรียกใช้ได้ทั้งหน้า detail (opportunity เดียวคงที่) และตารางลิสต์ (เปิดให้แถวไหนก็ได้)
export function useFinishJob({ onChanged, showSnack }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [targetOpportunity, setTargetOpportunity] = useState(null);
  const [result, setResult] = useState('WON');
  const [poNumber, setPoNumber] = useState('');
  const [value, setValue] = useState('');
  const [note, setNote] = useState('');
  const [docs, setDocs] = useState([emptyDocRow()]);
  const [saving, setSaving] = useState(false);

  const openDialog = (opportunity) => {
    setTargetOpportunity(opportunity);
    setResult('WON');
    setPoNumber('');
    setValue(opportunity?.value ?? '');
    setNote('');
    setDocs([emptyDocRow()]);
    setOpen(true);
  };
  const closeDialog = () => setOpen(false);

  const addDocRow = () => setDocs((rows) => [...rows, emptyDocRow()]);
  const removeDocRow = (rowId) => setDocs((rows) => rows.filter((r) => r.rowId !== rowId));
  const setDocName = (rowId, name) => setDocs((rows) => rows.map((r) => (r.rowId === rowId ? { ...r, name } : r)));
  const setDocFile = (rowId, file) => setDocs((rows) => rows.map((r) => (r.rowId === rowId ? { ...r, file } : r)));

  const confirm = async () => {
    setSaving(true);
    try {
      await dispatch(actions.changeOpportunityStatus({
        id: targetOpportunity.id,
        toStatus: result,
        note: note || undefined,
        poNumber: result === 'WON' ? (poNumber || undefined) : undefined,
        value: result === 'WON' && value !== '' ? Number(value) : undefined,
      }));

      if (result === 'WON') {
        const filledRows = docs.filter((r) => r.name.trim() && r.file);
        const failedUploads = [];
        for (const row of filledRows) {
          try {
            // eslint-disable-next-line no-await-in-loop
            const uploadResult = await dispatch(actions.uploadTenderDocuments({
              opportunityId: targetOpportunity.id, docType: row.name.trim(), files: [row.file],
            }));
            if (uploadResult.failed?.length) failedUploads.push(row.name);
          } catch (err) {
            failedUploads.push(row.name);
          }
        }
        if (failedUploads.length) {
          showSnack(`แนบเอกสารไม่สำเร็จ: ${failedUploads.join(', ')}`, 'error');
        }
      }

      showSnack('บันทึกจบงานสำเร็จ');
      closeDialog();
      onChanged();
    } catch (err) {
      showSnack(err.message || 'บันทึกไม่สำเร็จ', 'error');
    } finally {
      setSaving(false);
    }
  };

  return {
    open,
    result,
    setResult,
    poNumber,
    setPoNumber,
    value,
    setValue,
    note,
    setNote,
    docs,
    addDocRow,
    removeDocRow,
    setDocName,
    setDocFile,
    saving,
    openDialog,
    closeDialog,
    confirm,
  };
}

export default useFinishJob;
